<template>
  <div :class="isChecked && 'rd-checked'">
    <div :class="['rd-container', disabled && 'rd-disabled']" @click="click">
      <label class="rdi">
        <input type="radio" :name="name" @click="click" :value="option" :checked="isChecked" :disabled="disabled">
        <span class="rd-check" />
      </label>
      <p v-if="title" class="rd-title">
        {{ title }}
      </p>
      <p v-else class="rd-title">
        <slot name="title" />
      </p>

      <Badge
        v-show="withBadge"
        class="bdg-warning"
      >
        Online
      </Badge>
    </div>
    <div class="rd-content">
      <slot name="info" />
    </div>
    <div v-if="checked" class="rd-content">
      <slot name="default"/>
    </div>
  </div>
</template>

<script>
import Badge from '@/components/Badge/Badge.vue';

export default {
  name: 'RadioButton',
  components: {
    Badge,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    withBadge: {
      type: Boolean,
    },
    option: {
      type: [Object, String, Number, Boolean],
      required: true,
    },
    value: {
      type: [Object, String, Number, Boolean],
      required: false,
    },
    name: {
      type: String,
      required: false,
      default: 'default_group',
    },
    checked: {
      type: Boolean,
      required: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    click() {
      if (!this.disabled) {
        this.$emit('input', this.option);
      }
    },
  },
  computed: {
    isChecked() {
      return this.value !== undefined && this.value === this.option;
    },
  },
};
</script>
